<script lang="ts" setup>
import { RouterView } from "vue-router";
</script>

<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<style>
@import "@/assets/styles/base.css";
@import "@/assets/styles/general.css";
</style>
